import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Routes,
    Navigate,
} from "react-router-dom";

import { ConfigPage } from "@/pages/cms/config";
import { ProductDetailPage, ProductListPage } from "@/pages/cms/products";
import { OrderListPage } from "@/pages/cms/order";

import { DatabasePage } from "@/pages/database";
import { LoginPage } from "@/pages/auth";

import { HomePage, CartPage } from "@/pages/web";

const App = () => {
    return (
        <Router>
            <Routes>
                {/* CMS Database Route */}
                <Route path="/database" element={<DatabasePage />} />

                {/* Web Route */}
                <Route path="/" element={<HomePage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/login" element={<LoginPage />} />

                {/* CMS Routes */}
                <Route path="/cms/product" element={<ProductListPage />} />
                <Route path="/cms/product/:productId" element={<ProductDetailPage />} />
                <Route path="/cms/order" element={<OrderListPage />} />
                <Route path="/cms/order/:orderId" element={<OrderListPage />} />
                <Route path="/cms/config" element={<ConfigPage />} />

                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
};

export default App;
